import React from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
}
export const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  action,
  noPadding = false,
  className = '',
  ...props
}) => {
  return <div className={`bg-white shadow rounded-lg overflow-hidden border border-gray-200 ${className}`} {...props} data-id="element-83">
      {(title || action) && <div className="px-4 py-5 sm:px-6 border-b border-gray-200 flex justify-between items-center bg-gray-50" data-id="element-84">
          <div data-id="element-85">
            {title && <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-86">
                {title}
              </h3>}
            {subtitle && <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-87">{subtitle}</p>}
          </div>
          {action && <div data-id="element-88">{action}</div>}
        </div>}
      <div className={noPadding ? '' : 'px-4 py-5 sm:p-6'} data-id="element-89">{children}</div>
    </div>;
};